interface Props {
	iconColor?: string;
	width?: string;
	height?: string;
}
const AddIcon = ({ iconColor = '#212529', width = '18', height = '18' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M3 9L15 9" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M9 3L9 15" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default AddIcon;
